import React from 'react';
import {classes, st} from '../../../common/components/Layout/Layout.st.css';
import {MainLoader} from '../../../common/components/Layout/MainLoader/MainLoader';
import {AsideLoader} from '../../../common/components/Layout/AsideLoader/AsideLoader';
import {HeaderLoader} from '../../../common/components/Layout/HeaderLoader/HeaderLoader';
import {A11yIds, SPECS} from '../../../common/constants';
import {useExperiments, useEnvironment} from '@wix/yoshi-flow-editor';
import {Spinner} from '@wix/wix-ui-tpa/cssVars';

export enum LoadingLayoutDataHooks {
  root = 'LoadingLayoutDataHooks.root',
  mainSection = 'LoadingLayoutDataHooks.mainSection',
  oneColumnViewSummary = 'LoadingLayoutDataHooks.oneColumnViewSummary',
  twoColumnViewSummary = 'LoadingLayoutDataHooks.twoColumnViewSummary',
  verticalDivider = 'LoadingLayoutDataHooks.verticalDivider',
  spinner = 'LoadingLayoutDataHooks.spinner',
}

export interface LoadingLayoutProps {
  isOneColumnView?: boolean;
}

export const LoadingLayout = ({isOneColumnView}: LoadingLayoutProps) => {
  const {experiments} = useExperiments();
  const {isEditor} = useEnvironment();
  const ecomCheckoutBrandStyling = experiments.enabled(SPECS.ecomCheckoutBrandStyling);
  /* istanbul ignore next */
  const mainClass = ecomCheckoutBrandStyling ? classes.main : classes.deprecatedMain;
  /* istanbul ignore next */
  const asideClass = ecomCheckoutBrandStyling ? classes.aside : classes.deprecatedAside;

  if (isEditor) {
    return (
      <div className={classes.spinnerContainer}>
        <Spinner data-hook={LoadingLayoutDataHooks.spinner} isCentered={true} />
      </div>
    );
  }

  return (
    <div data-hook={LoadingLayoutDataHooks.root} className={st(classes.root)}>
      <HeaderLoader />
      <div className={classes.container}>
        {isOneColumnView && <aside data-hook={LoadingLayoutDataHooks.oneColumnViewSummary} className={asideClass} />}
        <section className={mainClass} data-hook={LoadingLayoutDataHooks.mainSection}>
          <MainLoader />
        </section>
        {!isOneColumnView && <div data-hook={LoadingLayoutDataHooks.verticalDivider} className={classes.divider} />}
        <section
          aria-labelledby={A11yIds.SummarySection}
          data-hook={LoadingLayoutDataHooks.twoColumnViewSummary}
          className={asideClass}>
          <AsideLoader />
        </section>
      </div>
    </div>
  );
};
